import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "surface-section px-6 py-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 font-medium text-3xl mb-2" }, "Settings", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-5 p-0 text-600 line-height-3" }, "Manage your integrations and account preferences.", -1)
const _hoisted_4 = {
  key: 0,
  class: "flex align-items-center p-3 mb-4 bg-yellow-100 text-yellow-900 border-round"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle mr-3 text-xl" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Connect your Twilio account to use SMS features like purchasing numbers and sending campaigns.", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "surface-card shadow-2 p-4 border-1 border-50 border-round" }
const _hoisted_9 = { class: "flex align-items-start justify-content-between flex-column md:flex-row" }
const _hoisted_10 = { class: "flex align-items-center mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-900 font-medium text-xl mr-3" }, "Twilio", -1)
const _hoisted_12 = {
  key: 0,
  class: "m-0 text-600 line-height-3"
}
const _hoisted_13 = { class: "font-medium text-900" }
const _hoisted_14 = {
  key: 1,
  class: "m-0 text-600 line-height-3",
  style: {"max-width":"40rem"}
}
const _hoisted_15 = { class: "mt-3 md:mt-0 flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog),
    _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"78vh"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          (_ctx.connectRequired && !_ctx.isTwilioConnected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  (_ctx.isTwilioConnected)
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 0,
                        severity: "success",
                        value: "Connected"
                      }))
                    : (_openBlock(), _createBlock(_component_Tag, {
                        key: 1,
                        severity: "warning",
                        value: "Not Connected"
                      }))
                ]),
                (_ctx.isTwilioConnected)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                      _createTextVNode(" Connected as "),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.maskedSid), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_14, " Smsify sends messages and purchases phone numbers through your own Twilio account. Connect your account to enable SMS features. You'll be taken to Twilio to log in (or sign up) and approve access, then brought back here. "))
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.isTwilioConnected)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      label: "Disconnect",
                      icon: "pi pi-times",
                      severity: "danger",
                      outlined: "",
                      onClick: _ctx.confirmDisconnect
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: "Connect with Twilio",
                      icon: "pi pi-link",
                      onClick: _ctx.connectWithTwilio
                    }, null, 8, ["onClick"]))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}